import { type LatLng as SphericalLatLng } from 'spherical-geometry-js';
import { type LatLng } from '../../types/latLng';

export const sphericalLatLngToLatLng = (latLng: SphericalLatLng): LatLng => ({
  lat: latLng.lat(), lng: latLng.lng(),
});
